// eslint-disable-next-line import/no-extraneous-dependencies
import styled from 'styled-components';
export const LoadingContainer = styled.div `
  .root-app_loading-container {
    background-color: var(--color-neutral-background);

    .root-app_loading {
      display: flex;
      width: 100%;
      height: 100%;
      align-items: center;
      justify-content: center;

      .root-app_loading-ring {
        display: inline-block;
        position: relative;
        width: 72px;
        height: 72px;

        div {
          box-sizing: border-box;
          display: block;
          position: absolute;
          width: 64px;
          height: 64px;
          margin: 4px;
          border: 4px solid var(--color-action-default);
          border-radius: 50%;
          animation: loading-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
          border-color: var(--color-action-default) transparent transparent
            transparent;

          &:nth-child(1) {
            animation-delay: -0.45s;
          }
          &:nth-child(2) {
            animation-delay: -0.3s;
          }
          &:nth-child(3) {
            animation-delay: -0.15s;
          }
        }
      }
    }
  }

  @keyframes loading-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
//# sourceMappingURL=style.js.map